import { render, staticRenderFns } from "./pushRuleForm.vue?vue&type=template&id=27421dec&scoped=true"
import script from "./pushRuleForm.vue?vue&type=script&lang=js"
export * from "./pushRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27421dec",
  null
  
)

export default component.exports